import { onMounted, onUnmounted } from 'vue'

export function useKeyboardShortcuts(handlers = {}) {
  const handleKeyDown = (event) => {
    // Ignorer les raccourcis dans les champs de saisie
    if (event.target.tagName === 'INPUT' || 
        event.target.tagName === 'TEXTAREA' || 
        event.target.contentEditable === 'true') {
      return
    }

    const key = event.key.toLowerCase()
    const ctrl = event.ctrlKey || event.metaKey
    const shift = event.shiftKey
    const alt = event.altKey

    // Construire la combinaison de touches
    const combination = [
      ctrl && 'ctrl',
      shift && 'shift', 
      alt && 'alt',
      key
    ].filter(Boolean).join('+')
    
    // Debug
    console.log('Key pressed:', event.key, 'Combination:', combination, 'Handlers available:', Object.keys(handlers))

    // Raccourcis globaux - vérifier d'abord les handlers spécifiques
    let handled = false
    
    switch (combination) {
      case 'ctrl+z':
        if (handlers['ctrl+z']) {
          event.preventDefault()
          handlers['ctrl+z'](event)
          handled = true
        }
        break
      case 'ctrl+a':
        if (handlers['ctrl+a']) {
          event.preventDefault()
          handlers['ctrl+a'](event)
          handled = true
        }
        break
      case 'delete':
      case 'backspace':
        if (handlers.delete || handlers['delete']) {
          event.preventDefault()
          const handler = handlers.delete || handlers['delete']
          handler(event)
          handled = true
        }
        break
      case 'escape':
        if (handlers.escape || handlers['escape']) {
          event.preventDefault()
          const handler = handlers.escape || handlers['escape']
          handler(event)
          handled = true
        }
        break
      case 'ctrl+shift+d':
        if (handlers['ctrl+shift+d']) {
          event.preventDefault()
          handlers['ctrl+shift+d'](event)
          handled = true
        }
        break
      case 'f2':
        if (handlers.f2 || handlers['f2']) {
          event.preventDefault()
          const handler = handlers.f2 || handlers['f2']
          handler(event)
          handled = true
        }
        break
      case 'ctrl+r':
        if (handlers['ctrl+r']) {
          event.preventDefault()
          handlers['ctrl+r'](event)
          handled = true
        }
        break
    }
    
    // Si pas géré par les raccourcis spéciaux, essayer les handlers génériques
    if (!handled && handlers[combination]) {
      event.preventDefault()
      handlers[combination](event)
    }
  }

  onMounted(() => {
    document.addEventListener('keydown', handleKeyDown)
  })

  onUnmounted(() => {
    document.removeEventListener('keydown', handleKeyDown)
  })

  return {
    handleKeyDown
  }
}